import { ActionType } from 'typesafe-actions';

export interface IConfigurationState {
  isLoadingCustomerLogo: boolean;
  customerLogoError: string | null;
  customerConfigurations: ICustomerConfigurations;
  localLogoUrl: string | undefined;
  cameraAccessDenied: boolean|null;
  serviceUnavailable: boolean;
  geolocationAccessNeeded: boolean;
  geolocationEnabled: boolean;
}

export type TConfigurationActions = ActionType<typeof import('./configuration.actions')>;

export type ThemeSettings = {
  headingColor: {
    red: number;
    green: number;
    blue: number;
    hue: number;
    saturation: number;
    lightness: number;
  };
  paragraphColor: {
    red: number;
    green: number;
    blue: number;
    hue: number;
    saturation: number;
    lightness: number;
  };
  primaryButtonBackgroundColor: {
    red: number;
    green: number;
    blue: number;
    hue: number;
    saturation: number;
    lightness: number;
  };
  primaryButtonTextColor: {
    red: number;
    green: number;
    blue: number;
    hue: number;
    saturation: number;
    lightness: number;
  };
  secondaryButtonBackgroundColor: {
    red: number;
    green: number;
    blue: number;
    hue: number;
    saturation: number;
    lightness: number;
  };
  secondaryButtonTextColor: {
    red: number;
    green: number;
    blue: number;
    hue: number;
    saturation: number;
    lightness: number;
  };
  successColor: {
    red: number;
    green: number;
    blue: number;
    hue: number;
    saturation: number;
    lightness: number;
  };
  errorColor: {
    red: number;
    green: number;
    blue: number;
    hue: number;
    saturation: number;
    lightness: number;
  };
  warningColor: {
    red: number;
    green: number;
    blue: number;
    hue: number;
    saturation: number;
    lightness: number;
  };
};

export interface Themes {
  default: ThemeSettings;
  dark: ThemeSettings;
}

export interface ICustomerConfigurations {
  inactivityTimeout: number | null;
  themes: Themes;
  privacyPolicySettings: {
    enabled: boolean;
    privacyPolicies: IPrivacyPolicy[];
  };
}

export interface IPrivacyPolicy {
  languageId: string,
  fileName: string
}

const CONFIGURATION_NAME = 'configuration';

const CONFIGURATION_STATE_KEYS = {
  isLoadingCustomerLogo: 'isLoadingCustomerLogo',
  customerLogoError: 'CustomerLogoError',
  customerConfigurations: 'customerConfigurations',
  localLogoUrl: 'localLogoUrl',
  cameraAccessDenied: 'cameraAccessDenied',
  inactivityTimeout: 'inactivityTimeout',
  serviceUnavailable: 'serviceUnavailable',
  geolocationAccessNeeded: 'geolocationAccessNeeded',
  geolocationEnabled: 'geolocationEnabled'
};

export { CONFIGURATION_NAME, CONFIGURATION_STATE_KEYS };
